/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} OkInputs */

const en_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ok`)
};

const fr_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ok`)
};

const de_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const it_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

const ru_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хорошо`)
};

const es_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De acuerdo`)
};

const zh_cn2_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`好的`)
};

const ja_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`わかりました`)
};

const hi_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ठीक है`)
};

const pt_pt2_ok = /** @type {(inputs: OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OK`)
};

/**
* | output |
* | --- |
* | "Ok" |
*
* @param {OkInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ok = /** @type {((inputs?: OkInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<OkInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ok(inputs)
	if (locale === "de") return de_ok(inputs)
	if (locale === "it") return it_ok(inputs)
	if (locale === "ru") return ru_ok(inputs)
	if (locale === "es") return es_ok(inputs)
	if (locale === "zh-CN") return zh_cn2_ok(inputs)
	if (locale === "ja") return ja_ok(inputs)
	if (locale === "hi") return hi_ok(inputs)
	if (locale === "pt-PT") return pt_pt2_ok(inputs)
	return en_ok(inputs)
});